// Header.js
import React, { useCallback } from 'react';
import '../App.css';

function Header() {
  const handleNavClick = useCallback((e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    const navbar = document.querySelector('.App-header');
    const navbarHeight = navbar ? navbar.offsetHeight : 0;

    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: targetPosition - navbarHeight,
        behavior: 'smooth',
      });
    }
  }, []);

  return (
    <div className="container-sm1">
      <nav className='App-header navbar navbar-expand-lg sticky-header'>
        <a className="navbar-brand" href="#">
          <div className="App-logo"><a href="#"></a></div>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
          aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-collapse collapse" id="navbarSupportedContent">
          <div className="navbar-nav container-sm">
            <a
              className="nav-item nav-link font-size250"
              href="#section-intro-black"
              onClick={(e) => handleNavClick(e, 'section-intro-black')}
            >
              Home
            </a>
            <a
              className="nav-item nav-link font-size250"
              href="#section-fixpreis"
              onClick={(e) => handleNavClick(e, 'section-fixpreis')}
            >
              Fixpreis
            </a>
            <a
              className="nav-item nav-link font-size250"
              href="#section-quality"
              onClick={(e) => handleNavClick(e, 'section-quality')}
            >
              Qualität
            </a>
            <a
              className="nav-item nav-link font-size250"
              href="#section-buchen"
              onClick={(e) => handleNavClick(e, 'section-buchen')}
            >
              Buchen
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
